import React from 'react'

import 'assets/css/pages/login.css'

const PageTitle = () => (
  <h1 className="page-title">
      Welcome to admin panel Dashboard<br />
    <small>Summary of things going on in getcraft and more</small>
  </h1>
)

export default PageTitle
